import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import enLocale from './en'
import zhLocale from './zh'
import zhtLocale from './zht'

Vue.use(VueI18n)

const messages = {
  en:{
    ...enLocale
  },
  zh:{
    ...zhLocale
  },
  zht:{
    ...zhtLocale
  }
}

const i18n = new VueI18n({
  // set locale
  // options:en | zh | es
  locale:Cookies.get('language') || 'zh',
  // set locale messages
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js